import { Outlet } from "react-router-dom";
import ClientsSettings from "../pages/settings/ClientsSettings";
import DiscountCodes from "../pages/settings/DiscountCodes";
import HeaderSettings from "../pages/settings/HeaderSettings";
import NewStocktaking from "../pages/settings/NewStocktaking";
import PaymentTypes from "../pages/settings/PaymentTypes";
import SalesSetting from "../pages/settings/SalesSetting";
import Salon from "../pages/settings/Salon";
import Services from "../pages/settings/Services";
import ServicesFees from "../pages/settings/ServicesFees";
import Settings from "../pages/settings/Settings";
import StocktakingDetails from "../pages/settings/StocktakingDetails";
import Taxes from "../pages/settings/Taxes";
import TeamMemberCommissions from "../pages/settings/TeamMemberCommissions";
import TeamMemberPermissions from "../pages/settings/TeamMemberPermissions";
import TeamMemberSettings from "../pages/settings/TeamMemberSettings";
import TeamMemberVacations from "../pages/settings/TeamMemberVacations";
import Tips from "../pages/settings/Tips";

const RoutesSettings = () => {
  return (
    <>
      <HeaderSettings />
      <Outlet />
    </>
  );
};

const routesSettings = [
  {
    path: "/settings",
    element: <RoutesSettings />,
    children: [
      {
        index: true,
        element: <Settings />,
      },
      {
        path: "salon",
        element: <Salon />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "sales",
        element: <SalesSetting />,
      },
      {
        path: "clients",
        element: <ClientsSettings />,
      },
      {
        path: "sales/taxes",
        element: <Taxes />,
      },
      {
        path: "sales/services-fees",
        element: <ServicesFees />,
      },
      {
        path: "sales/tips",
        element: <Tips />,
      },
      {
        path: "sales/payment-types",
        element: <PaymentTypes />,
      },
      {
        path: "sales/discount-codes",
        element: <DiscountCodes />,
      },
      {
        path: "services/:stocktaking",
        element: <StocktakingDetails />,
      },
      {
        path: "services/stocktaking",
        element: <NewStocktaking />,
      },
      {
        path: "team-member-settings",
        element: <TeamMemberSettings />,
      },
      {
        path: "team-member-settings/permissions",
        element: <TeamMemberPermissions />,
      },
      {
        path: "team-member-settings/commissions",
        element: <TeamMemberCommissions />,
      },
      {
        path: "team-member-settings/vacations",
        element: <TeamMemberVacations />,
      },
    ],
  },
];

export default routesSettings;
